import { FunctionComponent, useEffect, useState } from 'react';
import SubscriptionForm from './SubscriptionForm/SubscriptionForm';
import { H1, Text } from '@montel/montelpro-shared-components-v2';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ACCOUNT_API_GET_ACCOUNT, SYSTEM_ENTITIES_GET_ENTITY } from 'apiRoutes';
import { MontelAccount } from 'domain/account/interfaces';
import { SystemEntity } from 'domain/systemEntity/interfaces/SystemEntity';
import { SubscriberType } from 'domain/subscription/interfaces/SubscriberType';

const CreateSubscriptionPage: FunctionComponent = () => {
	const [searchParams] = useSearchParams();
	const [companyId, setCompanyId] = useState<number>();
	const [bundleId, setBundleId] = useState<number>();
	const [account, setAccount] = useState<MontelAccount>();
	const [systemEntity, setSystemEntity] = useState<SystemEntity>();

	useEffect(() => {
		const bundleId = searchParams.get('bundleId');
		const companyId = searchParams.get('companyId');
		const accountId = searchParams.get('accountId');
		const systemEntityId = searchParams.get('systemEntityId');

		async function getAccount() {
			const result = await axios.get(
				`${ACCOUNT_API_GET_ACCOUNT}?AccountId=${accountId}`,
			);

			if (result.status == 200) {
				setAccount(result.data);
			}
		}

		async function getSystemEntity() {
			const result = await axios.get(
				`${SYSTEM_ENTITIES_GET_ENTITY}?id=${systemEntityId}`,
			);

			if (result.status == 200) {
				setSystemEntity(result.data);
			}
		}

		const numberifiedCompanyId = Number(companyId);
		if (numberifiedCompanyId) {
			setCompanyId(numberifiedCompanyId);
		}

		const numberifiedBundleId = Number(bundleId);
		if (numberifiedBundleId) {
			setBundleId(numberifiedBundleId);
		}

		if (accountId) {
			getAccount();
		}

		if (systemEntityId) {
			getSystemEntity();
		}
	}, [searchParams]);

	return (
		<>
			<H1>Create subscription</H1>
			{account && (
				<>
					<Text size="sm">
						{`Note: ${account.firstName} ${account.lastName}, ${account.email.value} will automatically be assigned a seat`}
					</Text>
				</>
			)}
			{systemEntity && (
				<>
					<Text size="sm">
						{`Note: System entity ${systemEntity.displayName} will automatically be assigned a seat`}
					</Text>
				</>
			)}
			<SubscriptionForm
				assignToCompanyId={companyId}
				assignToSubscriber={account?.id ?? systemEntity?.id}
				bundleId={bundleId}
				subscriberType={
					!!systemEntity
						? SubscriberType.SystemEntity
						: SubscriberType.Account
				}
			/>
		</>
	);
};

export default CreateSubscriptionPage;
